<!--
  画面名：-
  概要： 計画書策定画面のステップバーのコンポーネント
  備考： -
-->

<template>
  <!-- 入力ステップ -->
  <div class="arrow">
    <ol>
      <li :class="{active: Selected === 'organize'}">{{$language.LabelPlanningStep1}}</li>
      <li :class="{active: Selected === 'flowDiagram'}">{{$language.LabelPlanningStep2}}</li>
    </ol>
  </div>
</template>

<script>
export default {
  // 親コンポーネントから値を取得
  props: {
    // 親コンポーネントから取得したページタイトル
    PageTitle: String,
    Selected: String
  }
}
</script>
<!-- style読み込み -->
<style lang="scss" scoped>
  @import '@/assets/scss/managementFunction/setting.scss';
</style>
